import React, { useState, useEffect, useContext } from "react";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "./Helper/Stepwizard";
import { useNavigate, useLocation } from "react-router-dom";
import { IlabBioPreference } from "../../typings/models/BioPreference";
import PersonalInformation from "./Helper/ProfileInformation";
import { IBioSampleDetails } from "../../typings/models/BioSampleDetails";
import { ICAVSMaster } from "../../typings/models/CAVSMaster";
import { IBioMaster } from "../../typings/models/BioMaster";
import {
  getBioCountryOfDestination,
  getBioCountryOfOrigin,
  getCAVSMaster,
} from "../../api/apimethods";
import { IReactSelectOption } from "../../typings/models/ReactSelectOption";
import { IBioVaccineType } from "../../typings/models/BioVaccineType";
import { IBioPurposeOfTest } from "../../typings/models/BioPurposeOfTest";
import { IBioVaccineName } from "../../typings/models/BioVaccineName";
import { IBioSamplesAndTests } from "../../typings/models/BioSamplesAndTests";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import moment from "moment";
import { IBioRequest } from "../../typings/interfaces/Requests/BioRequest";

import { BioMetaContext } from "../../App";
import Loader from "../../components/molecules/Loader";
import { NotifyType } from "../../utils/app-config";
import { notify } from "../../utils";

const stepWizardConfig: IStepwizardProps = {
  currentStep: 3,
  steps: [
    {
      name: "Choose Application",
    },

    {
      name: "Samples & Tests",
    },
    {
      name: "Review",
    },
    {
      name: "Cost & Confirm",
    },
    {
      name: "Acknowledgement",
    },
  ],
};

const CAVSBioReview = () => {
  let bannerName = "Application for Laboratory Testing";
  const location = useLocation();
  const navigate = useNavigate();

  const chooseApp = localStorage.getItem("choose-app");
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [purposeOfTestOptions, setPurposeOfTestOptions] =
    useState<IBioPurposeOfTest[]>();
  const { message } = notify();
  const [vaccineTypeOptions, setVaccineTypeOptions] =
    useState<IBioVaccineType[]>();
  const [vaccineNameOptions, setVaccineNameOptions] =
    useState<IBioVaccineName[]>();
  const [errorMessage, setErrorMessage] = useState("");
  const { BioMeta } = useContext(BioMetaContext);
  const [vaccineNameOptionsBak, setVaccineNameOptionsBak] =
    useState<IBioVaccineName[]>();
  const [bioSampleDetails, setBioSampleDetails] = useState<IBioSampleDetails>();
  const [samplesAndTests, setSamplesAndTests] =
    useState<IBioSamplesAndTests[]>();
  const [Preference, setPreference] = useState<IlabBioPreference[]>([]);
  const [countryOfOriginOptions, setCountryOfOriginOptions] =
    useState<ICodeMasterModel[]>();
  const [countryOfDestinationOptions, setCountryOfDestinationOptions] =
    useState<ICodeMasterModel[]>();
  const [bioSurveillanceProgramsOptions, setBioSurveillanceProgramsOptions] =
    useState<IReactSelectOption[]>([]);
  const [isHistoryExpanded, setHistoryExpanded] = useState(false);
  const [isVaccineExpanded, setVaccineExpanded] = useState(false);
  useEffect(() => {
    getMaster();
  }, []);
  const handleHistoryExpandToggle = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    setHistoryExpanded(!isHistoryExpanded);
  };
  const getMaster = async () => {
    try {
      setPageLoader(true);

      const response = await getCAVSMaster();
      if (response?.status === 200) {
        const cavsMaster: ICAVSMaster = response.data;
        const bioMaster: IBioMaster = cavsMaster.bioMasters;

        if (bioMaster) {
          const purposeTest = bioMaster.testPurpose;
          const purposeTestArr = Object.entries(purposeTest).map(
            ([name, id]) => ({
              id,
              name,
            })
          );
          setPurposeOfTestOptions(purposeTestArr);
          setVaccineTypeOptions(bioMaster.vaccineTypes);
          setVaccineNameOptionsBak(bioMaster.vaccineNames);
          const bioSurveillanceProgram = bioMaster.bioSurveillancePrograms;
          if (bioSurveillanceProgram) {
            const bioSurveillanceProgramArr = bioSurveillanceProgram.map(
              (result: any) => ({
                label: result.name,
                value: result.CodeValue,
              })
            );
            setBioSurveillanceProgramsOptions(bioSurveillanceProgramArr);
          }
        }
      }

      const countryRes = await getBioCountryOfDestination();
      setCountryOfDestinationOptions(countryRes?.data || []);

      const conutryRes = await getBioCountryOfOrigin();
      setCountryOfOriginOptions(conutryRes?.data || []);

      const meta: IBioRequest = BioMeta.BioMeta;
      if (Object.keys(meta)?.length) {
        const {
          labBIOApplicationDetails,
          labBioSampleTestDetails,
          labBioPreference,
        } = meta;

        setBioSampleDetails(labBIOApplicationDetails);
        setSamplesAndTests(labBioSampleTestDetails);
        setPreference([labBioPreference]);
      }

      setPageLoader(false);
    } catch (ex) {
      console.error(ex);
      setPageLoader(false);
    }
  };

  const handlePreviousClick = async () => {
    const meta: IBioRequest = BioMeta.BioMeta;
    const applicationNumber = meta?.applicationNumber;
    const actionStatus = meta?.actionStatus;
    localStorage.setItem("ismetadata", "1");
    if (applicationNumber && actionStatus) {
      const url = `/bio-samples-and-tests?an=${applicationNumber}&type=${actionStatus}`;
      navigate(url);
    } else {
      navigate("/bio-samples-and-tests");
    }
  };

  const handleNextClick = () => {
    const modeOfPayment = localStorage.getItem("modeOfPayment");
    const meta: IBioRequest = BioMeta.BioMeta;
    const purposeOfTest = meta?.labBIOApplicationDetails?.purposeOfTest;

    if (purposeOfTest === 1 && modeOfPayment !== "Biosurveillance") {
      setErrorMessage(
        "You cannot proceed with Biosurveillance as the purpose of the test with other than Biosurveillance as the payment mode. Please select Biosurveillance as the payment mode or edit the purpose of the test in step 2."
      );
      message(NotifyType.Error, "Please check the error message.");
      return;
    }

    if (modeOfPayment === "Biosurveillance" && purposeOfTest !== 1) {
      setErrorMessage(
        "You cannot proceed with a Purpose of Application other than Biosurveillance since the payment mode is Biosurveillance. Please change the payment mode or edit the purpose of the test in step 2."
      );
      message(NotifyType.Error, "Please check the error message.");
      return;
    }

    setErrorMessage("");
    navigate("/bio-cost-and-confirm");
  };

  const handleVaccineExpandToggle = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    setVaccineExpanded(!isVaccineExpanded);
  };

  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />

        {errorMessage && (
          <div className="info-content">
            <div className="att">
              <br />
              <div className="text-danger">
                <center>{errorMessage}</center>
              </div>
            </div>
          </div>
        )}
        <PersonalInformation />
        <div className="info-heading">
          <h3 className="info-h3">Sample Details</h3>
        </div>

        {pageLoader ? (
          <Loader />
        ) : (
          <div className="info-content">
            <div className="row">
              <div className="row">
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="form-check-label" htmlFor="">
                        Purpose of Application
                        <span className="star-red">*</span>
                      </label>
                    </div>
                    <div className="col-lg-6">
                      <select
                        className={`form-select ${
                          !bioSampleDetails?.purposeOfTest
                            ? "border-danger op05"
                            : ""
                        }`}
                        aria-label="Default select example"
                        name="purposeOfTest"
                        value={bioSampleDetails?.purposeOfTest}
                        disabled
                      >
                        <option selected>-- Select --</option>
                        {purposeOfTestOptions &&
                          purposeOfTestOptions.map((x) => {
                            return <option value={x.id}>{x.name}</option>;
                          })}
                      </select>

                      {bioSampleDetails?.purposeOfTest === 7 && (
                        <div className="col-lg-12 mt-2">
                          <input
                            type="text"
                            disabled
                            className={`form-control ${
                              !bioSampleDetails?.otherPurposeOfTest
                                ? "border-danger op05"
                                : ""
                            }`}
                            placeholder="Enter Purpose of Application"
                            name="otherPurposeOfTest"
                            value={bioSampleDetails?.otherPurposeOfTest}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-lg-6">
                      <label htmlFor="crossReference">Cross Reference</label>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        id="crossReference"
                        name="crossReference"
                        value={bioSampleDetails?.crossReference}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-6">
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="form-check-label" htmlFor="samples">
                        Sample(s) to be collected or submitted?
                      </label>
                    </div>
                    <div className="col-lg-6">
                      <select
                        title="samples"
                        name="samplesCollectedOrSubmitted"
                        className="form-control"
                        value={bioSampleDetails?.samplesCollectedOrSubmitted}
                        disabled
                      >
                        <option value="Tobesubmitted">To be submitted</option>
                        <option value="Tobecollected">To be collected</option>
                      </select>
                    </div>
                  </div>
                </div> */}
              </div>
              {/* {bioSampleDetails?.samplesCollectedOrSubmitted ===
                "Tobecollected" && (
                <div className="row mt-2">
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <label
                          className="form-check-label"
                          htmlFor="courierName"
                        >
                          Courier Name
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <select
                          title="courierName"
                          name="courierName"
                          disabled
                          className="form-control"
                          value={bioSampleDetails?.courierName}
                        >
                          <option value="courierOption1">
                            Courier Option 1
                          </option>
                          <option value="courierOption2">
                            Courier Option 2
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row mt-2 mt-lg-0">
                      <div className="col-lg-6">
                        <label
                          className="form-check-label"
                          htmlFor="courierTrackingNumber"
                        >
                          Courier tracking number
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          id="courierTrackingNumber"
                          name="courierTrackingNo"
                          disabled
                          className="form-control"
                          value={bioSampleDetails?.courierTrackingNo}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
              {bioSampleDetails?.purposeOfTest === 1 && (
                <div className="row">
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <label className="form-check-label" htmlFor="">
                          Biosurveillance Program
                          <span className="star-red">*</span>
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <div className="col-lg-12 mt-2">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            name="bioSurveillanceProgram"
                            value={bioSampleDetails?.bioSurveillanceProgram}
                            disabled
                          >
                            <option selected>-- Select --</option>
                            {bioSurveillanceProgramsOptions &&
                              bioSurveillanceProgramsOptions.map((x) => {
                                return (
                                  <option value={x.label}>{x.label}</option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="row mt-2">
                <div className="col-lg-3">
                  <label className="form-check-label">Country of Origin</label>
                </div>
                <div className="col-lg-3">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    name="countryOfOrigin"
                    value={bioSampleDetails?.countryOfOrigin}
                    disabled
                  >
                    <option selected>-- Select --</option>
                    {countryOfOriginOptions &&
                      countryOfOriginOptions.map((x) => {
                        return (
                          <option key={x.name} value={x.name}>
                            {x.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="col-lg-3">
                  <label className="form-check-label">Date of Import</label>
                </div>
                <div className="col-lg-3">
                  <div className="input-group date" id="datepicker">
                    <input
                      type="date"
                      className="form-control"
                      name="dateOfImport"
                      value={
                        bioSampleDetails?.dateOfImport
                          ? moment(bioSampleDetails?.dateOfImport).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-lg-3">
                  <label className="form-check-label">
                    Sampling From Date <span className="star-red">*</span>
                  </label>
                </div>
                <div className="col-lg-3">
                  <input
                    type="datetime-local"
                    className={`form-control ${
                      bioSampleDetails?.samplingToDate &&
                      moment(bioSampleDetails?.samplingToDate).isBefore(
                        moment(bioSampleDetails?.samplingFromDate)
                      )
                        ? "border-danger"
                        : ""
                    }`}
                    name="samplingFromDate"
                    disabled
                    value={
                      bioSampleDetails?.samplingFromDate
                        ? moment(bioSampleDetails?.samplingFromDate).format(
                            "YYYY-MM-DDTHH:mm"
                          )
                        : ""
                    }
                  />
                </div>
                <div className="col-lg-3">
                  <label className="form-check-label">
                    Sampling To Date <span className="star-red">*</span>
                  </label>
                </div>
                <div className="col-lg-3">
                  <input
                    type="datetime-local"
                    className={`form-control ${
                      bioSampleDetails?.samplingFromDate &&
                      moment(bioSampleDetails?.samplingToDate).isBefore(
                        moment(bioSampleDetails?.samplingFromDate)
                      )
                        ? "border-danger"
                        : ""
                    }`}
                    name="samplingToDate"
                    disabled
                    value={
                      bioSampleDetails?.samplingToDate
                        ? moment(bioSampleDetails.samplingToDate).format(
                            "YYYY-MM-DDTHH:mm"
                          )
                        : ""
                    }
                  />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-lg-3">
                  <label htmlFor="sampledBy">
                    Sampled By <span className="star-red">*</span>
                  </label>
                </div>
                <div className="col-lg-3">
                  <input
                    type="text"
                    id="sampledBy"
                    name="sampledBy"
                    value={bioSampleDetails?.sampledBy}
                    disabled
                    className="form-control"
                  />
                </div>
                <div className="col-lg-3">
                  <label className="form-check-label">
                    Import Permit/Licence No.
                  </label>
                </div>
                <div className="col-lg-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    name="importPermitNo"
                    value={bioSampleDetails?.importPermitNo}
                    disabled
                  />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-lg-3">
                  <label className="form-check-label" htmlFor="">
                    No. of Vials Submitted
                  </label>
                </div>
                <div className="col-lg-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    name="noOfVialsSubmitted"
                    value={bioSampleDetails?.noOfVialsSubmitted}
                    disabled
                  />
                </div>
                <div className="col-lg-3">
                  <label className="form-check-label" htmlFor="">
                    Doses/Vial
                  </label>
                </div>
                <div className="col-lg-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    name="dosesVial"
                    value={bioSampleDetails?.dosesVial}
                    disabled
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-3">
                  <label className="form-check-label" htmlFor="">
                    Vaccine/Biologics Type <span className="star-red">*</span>
                  </label>
                </div>
                <div className="col-lg-3">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    name="vaccine_Biologics_Type"
                    id="vaccine-type-select"
                    value={bioSampleDetails?.vaccine_Biologics_Type}
                    disabled
                  >
                    <option selected>-- Select --</option>
                    {vaccineTypeOptions &&
                      vaccineTypeOptions.map((x) => {
                        return (
                          <option
                            data-vaccine-type-id={x.id}
                            value={x.description}
                          >
                            {x.description}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="col-lg-3">
                  <label className="form-check-label" htmlFor="">
                    Diluent Batch No.
                  </label>
                </div>
                <div className="col-lg-3">
                  <input
                    type="text"
                    className="form-control"
                    name="diluent_Batch_No"
                    value={bioSampleDetails?.diluent_Batch_No}
                    placeholder=""
                    disabled
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-3">
                  <label className="form-check-label" htmlFor="">
                    Vaccine Name
                  </label>
                </div>
                <div className="col-lg-3">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    name="vaccineName"
                    value={bioSampleDetails?.vaccineName}
                    disabled
                  >
                    <option selected>-- Select --</option>
                    {vaccineNameOptionsBak &&
                      vaccineNameOptionsBak.map((x) => {
                        return (
                          <option value={x.vaccineName}>{x.vaccineName}</option>
                        );
                      })}
                  </select>
                </div>
                <div className="col-lg-3">
                  <label className="form-check-label" htmlFor="">
                    Diluent Expiry Date
                  </label>
                </div>
                <div className="col-lg-3">
                  <div className="input-group date" id="datepicker">
                    <input
                      type="date"
                      className={`form-control`}
                      name="diluentExpiryDate"
                      value={
                        bioSampleDetails?.diluentExpiryDate
                          ? moment(bioSampleDetails?.diluentExpiryDate).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      disabled
                    />
                  </div>
                </div>
                <br />
              </div>

              <div className="row mt-2">
                <div className="col-lg-3">
                  <label
                    className="form-check-label"
                    htmlFor="countryOfDestination"
                  >
                    Country of Destination
                  </label>
                </div>
                <div className="col-lg-3">
                  <select
                    id="countryOfDestination"
                    name="countryOfDestination"
                    value={bioSampleDetails?.countryOfDestination}
                    className="form-select"
                    disabled
                  >
                    <option value="" disabled hidden>
                      Choose a Country
                    </option>
                    {countryOfDestinationOptions &&
                      countryOfDestinationOptions.map((x) => {
                        return <option value={x.name}>{x.name}</option>;
                      })}
                  </select>
                </div>

                <div className="col-lg-3">
                  <label
                    className="form-check-label"
                    htmlFor="dateToBeExported"
                  >
                    Date to be Exported
                  </label>
                </div>
                <div className="col-lg-3">
                  <input
                    type="date"
                    id="dateToBeExported"
                    name="dateToBeExported"
                    value={
                      bioSampleDetails?.dateToBeExported
                        ? moment(bioSampleDetails?.dateToBeExported).format(
                            "YYYY-MM-DD"
                          )
                        : ""
                    }
                    className="form-control"
                    disabled
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-12">
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    <a
                      href=""
                      className="font-weight-500"
                      onClick={handleVaccineExpandToggle}
                    >
                      For Locally Manufactured Vaccines
                      {isVaccineExpanded ? "[-]" : "[+]"}
                    </a>
                  </label>
                </div>
              </div>
              {isVaccineExpanded && (
                <div className="row mt-3">
                  <div className="col-lg-3">
                    <label className="form-check-label" htmlFor="">
                      No. of Vials Produced
                      <span className="star-red">*</span>
                    </label>
                  </div>
                  <div className="col-lg-3">
                    <input
                      type="number"
                      className={`form-control ${
                        bioSampleDetails?.noOfvialsProducedErrMsg
                          ? "border-danger op05"
                          : ""
                      }`}
                      name="noOfVialsProduced"
                      disabled
                      value={bioSampleDetails?.noOfVialsProduced}
                    />
                  </div>

                  <div className="col-lg-3">
                    <label className="form-check-label" htmlFor="">
                      Date Produced
                    </label>
                  </div>
                  <div className="col-lg-3">
                    <div className="input-group date" id="datepicker">
                      <input
                        type="date"
                        className={`form-control`}
                        name="dateProduced"
                        value={
                          bioSampleDetails?.dateProduced
                            ? moment(bioSampleDetails?.dateProduced).format(
                                "YYYY-MM-DD"
                              )
                            : ""
                        }
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-lg-3 mt-2">
                    <label className="form-check-label" htmlFor="">
                      Substrate<span className="star-red">*</span>
                    </label>
                  </div>
                  <div className="col-lg-3 mt-2">
                    <input
                      type="text"
                      className={`form-control ${
                        bioSampleDetails?.substrateErrMsg
                          ? "border-danger op05"
                          : ""
                      }`}
                      placeholder=""
                      disabled
                      name="substrate"
                      value={bioSampleDetails?.substrate}
                    />
                  </div>
                </div>
              )}
              <div className="row mt-3">
                <div className="col-lg-12">
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    <a
                      href=""
                      className="font-weight-500"
                      onClick={handleHistoryExpandToggle}
                    >
                      History &amp; Remarks: {isHistoryExpanded ? "[-]" : "[+]"}
                    </a>
                  </label>
                </div>
              </div>
              {isHistoryExpanded && (
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <textarea
                      className="form-control"
                      id="floatingTextarea"
                      name="history_Remarks"
                      disabled
                      value={bioSampleDetails?.history_Remarks}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="info-heading mt-2">
          <h3 className="info-h3">Samples & Tests</h3>
        </div>
        {pageLoader ? (
          <Loader />
        ) : (
          samplesAndTests &&
          samplesAndTests.map((x: IBioSamplesAndTests, ind: number) => {
            return (
              <div className="personal-info">
                <div className="clonable-block" data-toggle="cloner">
                  <div className="clonable" data-clone-number={ind + 1}>
                    <div className="info-heading">
                      <h2 className="pb-0">Serial number {ind + 1}</h2>
                    </div>
                    <div className="info-content">
                      <div className="table-responsive mt-2 mb-2 ">
                        <table className="table table-striped product_table start_table">
                          <thead>
                            <tr>
                              <th className="w-20">
                                Sample Marking
                                <span className="star-red">*</span>
                              </th>
                              <th className="w-20">
                                Number of Samples
                                <span className="star-red">*</span>
                              </th>
                              <th className="w-20">Batch No.</th>
                              <th className="w-20">Expiry Date</th>
                              <th className="w-20">
                                Test Information
                                <span className="star-red">*</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  className={`form-control ${
                                    !x.sampleMarking ? "border-danger op05" : ""
                                  }`}
                                  name="sampleMarking"
                                  value={x?.sampleMarking}
                                  disabled
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="noOfSamples"
                                  value={x?.noOfSamples}
                                  disabled
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="batchNo"
                                  value={x?.batchNo}
                                  disabled
                                />
                              </td>
                              <td>
                                <div
                                  className="input-group date"
                                  id="datepicker"
                                >
                                  <input
                                    type="date"
                                    className={`form-control`}
                                    name="expiryDate"
                                    value={
                                      x.expiryDate
                                        ? moment(x.expiryDate).format(
                                            "YYYY-MM-DD"
                                          )
                                        : ""
                                    }
                                    disabled
                                  />
                                </div>
                              </td>
                              <td>
                                <button
                                  className="btn btn-outline-success w-100 "
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#staticBackdrop1"
                                  disabled
                                >
                                  Search Test
                                </button>
                              </td>
                            </tr>

                            {/*<tr>
                              <td className="fnt-wg tr-ignore">
                                <div className="mb-3 ">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="staticEmail"
                                      className="col-form-label"
                                    >
                                      Latitude (Decimal Degrees)
                                    </label>
                                    <div className="input-group date">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name="latitude"
                                        value={x?.latitude}
                                        disabled
                                      />
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td className="fnt-wg tr-ignore">
                                <div className="mb-3 ">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="staticEmail"
                                      className="col-form-label"
                                    >
                                      Longitude (Decimal Degrees)
                                    </label>
                                    <div className="input-group date">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name="longitude"
                                        value={x?.longitude}
                                        disabled
                                      />
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>*/}

                            {x.labBioTestDetails &&
                              x.labBioTestDetails
                                .filter((test) => test.testDescription !== "")
                                .map((test, testIndex) => (
                                  <tr key={`test-row-${ind}-${testIndex}`}>
                                    <td className="br-1" colSpan={3}>
                                      <div className="mb-3">
                                        <div className="mb-2">
                                          <div className="test-detail">
                                            <div
                                              id={`testDescription-${ind}-${test.labTestID}`}
                                              className="test-description"
                                              dangerouslySetInnerHTML={{
                                                __html: test.testDescription,
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </td>

                                    <td
                                      className="fnt-wg tr-ignore"
                                      colSpan={2}
                                    >
                                      <div className="mb-3">
                                        <div className="mb-2">
                                          <label
                                            htmlFor={`repeatCount-${ind}-${testIndex}`}
                                            className="col-form-label float-start"
                                          >
                                            Number of Tests
                                            <span className="star-red">*</span>
                                          </label>
                                          <div className="input-group date">
                                            <input
                                              type="number"
                                              id={`repeatCount-${ind}-${testIndex}`}
                                              min="1"
                                              className="form-control"
                                              value={
                                                test.nooftestsrequired ?? 1
                                              }
                                              disabled
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
        <div className="info-heading mt-2">
          <h3 className="info-h3">My Preference</h3>
        </div>
        {pageLoader ? (
          <Loader />
        ) : (
          Preference &&
          Preference.map((x: IlabBioPreference, ind: number) => {
            return (
              <div className="personal-info" key={ind}>
                <div className="clonable-block">
                  <div className="clonable">
                    <div className="info-content">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="SpecialInstructions"
                              >
                                For Bacterial Culture Only
                              </label>
                            </div>
                            <div className="col-lg-7 d-flex align-items-center">
                              <input
                                type="checkbox"
                                className="form-check-input me-2"
                                disabled
                                name="antimicrobialSusceptibilityTestRequired"
                                checked={
                                  x?.antimicrobialSusceptibilityTestRequired
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="antimicrobialSusceptibilityTestRequired"
                              >
                                Antimicrobial Susceptibility Test Required
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="specialInstructions"
                              >
                                Special Instructions/ Additional Information
                              </label>
                            </div>
                            <div className="col-lg-7">
                              <textarea
                                className="form-control"
                                name="specialInstructions"
                                value={x.specialInstructions}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="row mt-2 mt-lg-0">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="otherRemarks"
                              >
                                Other Remarks
                              </label>
                            </div>
                            <div className="col-lg-7">
                              <textarea
                                className="form-control"
                                name="resultReportingInstr"
                                value={x.remarks}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="supportDocuments"
                              >
                                Support Documents
                              </label>
                            </div>
                            <div className="col-lg-7">
                              <div className="file-view mt-2">
                                {x?.supportDocumentName
                                  ? x.supportDocumentName
                                  : "No file attached"}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6 mt-3">
                          <div className="row">
                            <div className="col-lg-5">
                              <label
                                className="form-check-label"
                                htmlFor="modeOfReceiving"
                              >
                                Mode of receiving report
                                <span className="star-red">*</span>
                              </label>
                            </div>
                            <div className="col-lg-7">
                              <select
                                name="modeOfReceiving"
                                disabled
                                value={x?.modeOfReceiving}
                                className="form-select"
                                aria-label="Mode of receiving report"
                              >
                                <option value="" disabled>
                                  Select an option
                                </option>
                                <option value={2}>Email</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {x?.modeOfReceiving === 1 && (
                          <div className="row mt-2">
                            <div className="col-lg-6">
                              <label className="form-check-label fw-bold mb-2">
                                Please select the address for mailing:
                              </label>
                              <select
                                name="mailingAddress"
                                className="form-select mb-3"
                                value={x?.mailingAddress}
                                disabled
                              >
                                <option value="" disabled hidden>
                                  Please Select address
                                </option>
                                <option value={1}>
                                  Same as mailing address
                                </option>
                                <option value={2}>
                                  Same as billing address
                                </option>
                                <option value={3}>
                                  Others (please specify)
                                </option>
                              </select>

                              {x?.mailingAddress === 3 && (
                                <div className="col-lg-12">
                                  <textarea
                                    className="form-control mt-2"
                                    placeholder="Enter address"
                                    name="customAddress"
                                    disabled
                                    value={x?.customAddress}
                                  />
                                </div>
                              )}

                              <div className="alert alert-warning mt-3">
                                Please note that NParks is not liable for lost
                                mail, and any additional copies of laboratory
                                reports are subject to additional charges.
                              </div>

                              <div className="form-check mt-3">
                                <input
                                  type="checkbox"
                                  className="form-check-input mt-2"
                                  id="acknowledgeCheckbox"
                                  name="acknowledge"
                                  disabled
                                  checked={x?.acknowledge || false}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="acknowledgeCheckbox"
                                >
                                  I acknowledge the above information
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}

        <div className="text-end mt-3 mb-3">
          <button
            className="btn btn-d btn-secondary px-4"
            onClick={handlePreviousClick}
          >
            Previous
          </button>
          <button
            className="btn btn-d btn-primary nextBtn"
            name="next-click"
            type="button"
            onClick={handleNextClick}
          >
            Next
          </button>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default CAVSBioReview;
